import React, { Component } from 'react';
import { tipoUnidad } from '../libs/utils/Const';

const changeScop = (scop) => {

}
const renderTableBody = (headers, data, checkbox) => {
    let body = "";
    const generateCorrelative = (base, index) => {
        const length = base.length;
        const baseNumber = parseInt(base, 10);

        const result = baseNumber + index;

        return result.toString().padStart(length, '0');
    };
    body = data.map((register, index) => {
        let lines = register?.lines ?? []
        const isOpenRow = checkbox?.openRows?.[index] ?? false

        lines = [...new Set(lines.map(l => l?.DocNumSolicitud ?? ''))].join(',');
        return (
            <>
                <tr key={index}>
                    {headers[0].value && <td className="dataTables-body-center">{`${register.DocEntryODRF}-${register.DocNumODRF}`}</td>}
                    {headers[1].value && <td className="dataTables-body-center" style={{ maxWidth: '20px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={lines || ''}>{lines || ''}</td>}
                    {/* {headers[2].value && <td className="dataTables-body-center">{register.U_BPP_NDSD || ''}</td>} */}
                    {/* {headers[3].value && <td className="dataTables-body-center">{register.U_BPP_NDCD || ''}</td>} */}
                    {/* {headers[4].value && <td className="dataTables-body-center">{generateCorrelative(register.U_BPP_NDCD || '', index)}</td>} */}
                    {/* {headers[5].value && (
                        <td className="dataTables-body-center">
                            <input
                                type="text"
                                value={register?.U_FMB_SCOP_CODE ?? ''}
                                // onChange={(e) => this.changeScop(e, index)}
                                className="form-control"
                            />
                        </td>
                    )} */}
                    <td className="sticky-columns dataTables-body-center" style={{ backgroundColor: "#e9ecef" }}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => checkbox.onChangeOpenRow(index)}
                            // disabled={(checkbox.view == 'invoiceAuthorization')}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> {isOpenRow ? '-' : '+'}
                        </button>
                    </td>

                </tr>
                {isOpenRow && (
                    <tr>
                        <td colSpan="6">
                            <div>
                                {/* Encabezado */}
                                <div style={{ display: 'flex', fontWeight: 'bold' }}>
                                    <div style={{ width: '20%' }}>N° Solicitud</div>
                                    <div style={{ width: '20%' }}>Serie</div>
                                    <div style={{ width: '20%' }}>Correlativo</div>
                                    <div style={{ width: '20%' }}>SCOP</div>
                                </div>

                                {/* Filas */}
                                {[...new Map(
                                    (register?.lines ?? [])
                                        .map(line => [line.DocEntrySolicitud, line])
                                ).values()].map((line, i) => (
                                    <div key={i} style={{ display: 'flex', marginTop: 5, color: line.ValidSCOP ? 'green' : (checkbox.view == 'invoiceBorrador') ? 'red' : 'black' }}>
                                        <div style={{ width: '20%' }}>
                                            {line.DocNumSolicitud}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            {line.U_BPP_NDSD ?? ''}
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            {generateCorrelative(line.U_BPP_NDCD || '', i)}
                                        </div>
                                        <div style={{ width: '20%', display: 'flex', alignItems: 'center', gap: '5px' }}>

                                            <input
                                                type="text"
                                                value={line.U_FMB_SCOP_CODE || ''}
                                                onChange={(e) => checkbox.onChangeSCOP(
                                                    register.DocEntryODRF,
                                                    line.DocEntrySolicitud,
                                                    e.target.value
                                                )}
                                                style={{ flex: 1 }}
                                            />
                                            {(checkbox.view == 'invoiceBorrador' || checkbox.view == 'reabsResume') &&
                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                    className="input-group-text"
                                                    onClick={() => checkbox.ValidateScoopCode(
                                                        register.DocEntryODRF,
                                                        line.DocEntrySolicitud,
                                                        line.U_FMB_SCOP_CODE
                                                    )}
                                                >
                                                    <i className="fa fa-cloud" aria-hidden="true" />
                                                </button>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </td>
                    </tr>
                )}
            </>
        )
    })
    return body;
};

const renderTable = (headers, data, checkbox) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td className="dataTables-header-center">{headers[0].title}</td>}
            {headers[1].value && <td className="dataTables-header-center">{headers[1].title}</td>}
            {/* {headers[2].value && <td className="dataTables-header-center">{headers[2].title}</td>}
            {headers[3].value && <td className="dataTables-header-center">{headers[3].title}</td>} */}
            {/* {headers[4].value && <td className="dataTables-header-center">{headers[4].title}</td>} */}
            {/* {headers[5].value && <td className="dataTables-header-center">{headers[5].title}</td>} */}
            <td className="sticky-columns dataTables-header-center" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox);

    let table = "";

    table = <table id="dataTableGuide" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableSunatGuide = (headers, data, checkbox) => {

    return renderTable(headers, data, checkbox);

}